module.exports = __webpack_public_path__ + "static/scale-model-of-powellswood-garden-in-tacoma-washington-dfc38155261a298dbce99e90204c1198.png";